module.exports = __webpack_public_path__ + "img/swap.2717a63e.svg";